import { useNavigator } from '@repo/toolkit/use-navigator'
import Box from '@repo/ui/box'
import { DocumentIcon } from '@repo/ui/icons'
import { useMutation, useQuery } from '@tanstack/react-query'
import { useParams } from 'react-router-dom'
import { toast } from 'sonner'

import { getEndOfJourneyTemplate } from '../../../api/end-of-journey-templates/get-end-of-journey-template'
import { updateEndOfJourneyTemplate } from '../../../api/end-of-journey-templates/update-end-of-journey-template'
import { ItemNotFound } from '../../../components/elements/item-not-found'
import LoadingScreen from '../../../components/elements/loading/loading-screen'
import UserNavBar from '../../../components/elements/nav-bar'
import EndOfStayTemplateForm from '../../../components/pages/surveys/end-of-stay-template-form'
import { Paths } from '../../../lib/constants/path'
import { updateButtonsConfig } from '../../../lib/utils/buttons-config/validation-buttons-config'
import { showAxiosError } from '../../../lib/utils/functions/misc.functions'
import NotFoundPage from '../../common/not-found'

const EndOfStayTemplateUpdatePage = () => {
  const { navigate, back } = useNavigator()
  const { id } = useParams<{ id: string }>()

  if (!id || isNaN(parseInt(id)))
    return <ItemNotFound title="Identifiant de modèle d'enquête invalide" />

  const { data, isPending, refetch } = useQuery({
    queryFn: () => getEndOfJourneyTemplate(parseInt(id)),
    queryKey: ['end-of-journey-template', id]
  })

  const { mutateAsync: updateTemplateMutation } = useMutation({
    mutationFn: updateEndOfJourneyTemplate,
    onError: showAxiosError,
    onSuccess: () => {
      refetch()
      toast.success("Modèle d'enquête modifié avec succès")
    }
  })

  if (isPending) return <LoadingScreen />
  if (!data) return <NotFoundPage />

  return (
    <div>
      <UserNavBar title="Modifier le modèle d'enquête de fin de séjour" icon={DocumentIcon} />
      <div className="h-4" />
      <Box>
        <EndOfStayTemplateForm
          defaultValues={{
            name: data.name,
            optionIds: data.options.map((option) => option.id),
            productIds: data.products.map((product) => product.id)
          }}
          buttonsConfig={updateButtonsConfig({
            onCancel: () => back(Paths.SURVEY_END_OF_STAY_TEMPLATES_LIST_PAGE),
            onUpdate: (values) => updateTemplateMutation({ id: parseInt(id), ...values }),
            onUpdateThenCreate: async (values) => {
              await updateTemplateMutation({ id: parseInt(id), ...values })
              navigate(Paths.SURVEY_END_OF_STAY_TEMPLATE_CREATE_PAGE)
            },
            onUpdateThenList: async (values) => {
              await updateTemplateMutation({ id: parseInt(id), ...values })
              back(Paths.SURVEY_END_OF_STAY_TEMPLATES_LIST_PAGE)
            }
          })}
        />
      </Box>
    </div>
  )
}

export default EndOfStayTemplateUpdatePage
